import React from "react";
import styles from './EvaluationStatus.module.scss';
import PropTypes from "prop-types";

const EvaluationStatus = ({ status }) => {
  return (
    <div className={styles[status.toLowerCase()] ?? ''}>
      {status === 'Accepted' ? 
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <circle cx="10" cy="10" r="10" fill="#F0F0FF"/>
          <path d="M6 10.8421L9.10345 14L15 8" stroke="#171898" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg> : 
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="10" cy="10" r="10" fill="#FFE2E2"/>
          <path d="M14 6L6 14M6 6L14 14" stroke="#FF4646" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>}
      <span>{status}</span>
    </div>
  );
}

EvaluationStatus.propTypes = {
  status: PropTypes.oneOf(['Accepted', 'Declined']).isRequired
}

export default EvaluationStatus;